<template>
  <!-- 购买企业套餐服务 -->
  <div class="buy-cps ">
    <!-- <banner></banner> -->
    <div class="DgrayBg yregister">
      <div class="w1200 flow">
        <h2>选择商品配置</h2>
        <ul>
          <li>
            <i class="step">1</i>添加清单</li>
          <li>
            <i class="step">2</i>确认订单</li>
          <li>
            <i>3</i>在线支付</li>
          <li>
            <i>4</i>支付成功</li>
        </ul>
      </div>
    </div>

    <div class="grayBg yregister"
         style="padding:20px 0 40px;">
      <Order-panel titleName="选择套餐包">
        <div>
          <a href="javascript:;"
             class="choose-package-item"
             v-for="item in domainPackageList">
            <input type="radio"
                   v-model="domainPackage"
                   class="label-rio"
                   name="label-btn"
                   :value="item.code"
                   :id="item.code">
            <label :for="item.code"
                   class="label-name">{{item.name}}</label>
          </a>

        </div>
      </Order-panel>
      <Order-panel titleName="查询域名">
        <div class=""
             style="width: 608px;position:relative;">

          <el-input placeholder="请输入要查询的域名前缀..."
                    v-model="domainName"
                    class="input-with-select">
            <el-button slot="append"
                       @click="query"
                       :disabled="disabledQuery">查询</el-button>
          </el-input>
          <p class="query-tip">提示：请先查询您想注册的域名是否已被注册</p>
          <div v-if="domainName.length<27"
               class="input-tip">{{domainPackageList[domainPackage].placeHolder}}</div>
          <div v-if="domainList.length>0"
               style=""
               class="domain-query-result">查询结果</div>
          <ul style="width: 680px;"
              :class="{'h100':domainName.length>0&& isQuery}"
              v-loading="disabledQuery">
            <li class="query-result-item"
                v-for="item in domainList"
                style="">
              <span class="c9 f12">{{item.domainName}}</span>
              <span class="fr f12"
                    style="color: #999999;"
                    v-if="item.buyStatus == 1">
                已被注册，<a style="color: #108ee9;"
                   :href="`/domain/info?domain=${item.domainName}`"
                   target="_blank"
                   class="view-whois">查看Whois信息</a></span>
              <span style="color: #1fb09f;"
                    class="fr"
                    v-else-if="item.buyStatus == 2">可以注册</span>
              <span class="fr"
                    style="color: #999999;"
                    v-else>查询失败</span>
            </li>
          </ul>
        </div>
      </Order-panel>
      <Order-panel titleName="
                 选购套餐年限">
        <div class="">
          <a href="javascript:;"
             v-for="item in yearList">
            <input type="radio"
                   name="label-timelong"
                   v-model="timeLong"
                   :value="item.value"
                   class="label-rio"
                   :id="'year'+item.value">
            <label :for="'year'+item.value"
                   class="label-name">{{item.name}}</label>
          </a>
        </div>
      </Order-panel>
      <Order-panel titleName="选择域名服务">
        <a href="javascript:;"
           v-for="item in domainServerList">
          <input type="radio"
                 v-model="domainServer"
                 :value="item.id"
                 name="domainServer"
                 class="label-rio"
                 :id="item.id">
          <label :for="item.id"
                 class="label-name">{{item.goodsName}}</label>

        </a>
        <!-- <div class="el-icon-info"></div> -->
      </Order-panel>
      <Order-panel titleName="选择域名注册模板">
        <div class="regban">
          <section>
            <p>使用已实名的信息模板便于您注册域名后快速实名认证，可在信息模板中创建和管理。</p>
            <p>重要：.公司/.网络/.网店/.集团/.中文网/.企业/.cc 后缀不支持关联模板实名的状态，注册成功后必须在5个工作日内提交实名认证，避免影响域名正常使用。</p>
            <div class="selban"
                 v-if="wasLogin">
              <label v-for="(item,i) in templateList"
                     :key="i"
                     :class="{user:item.registrantType==='I'}">
                <input type="radio"
                       :value="item.id"
                       v-model="domainTemplateId">{{item.templateName}}
                <em>{{item.registrantTypeLabel}}注册信息</em>

                <el-button type="text"
                           @click="item.dialogVisible = true">详情</el-button>

                <el-dialog title="域名模板详情"
                           :visible.sync="item.dialogVisible"
                           width="40%">
                  <span class="dgcon-list">
                    <p>
                      <i>模板名称</i>
                      <b>{{item.templateName}}</b>
                    </p>
                    <p>
                      <i>所有者类型</i>
                      <b>{{item.apiType}}</b>
                    </p>
                    <p>
                      <i>域名所有者(中文)</i>
                      <b>{{item.nameCn}}</b>
                    </p>
                    <p>
                      <i>域名所有者(英文)</i>
                      <b>{{item.nameEn}}</b>
                    </p>
                    <p>
                      <i>资料认证状态</i>
                      <b>{{item.status}}</b>
                    </p>
                    <p>
                      <i>域名联系人(中文)</i>
                      <b>{{item.custLinkmanCn}}</b>
                    </p>
                    <p>
                      <i>域名联系人(英文)</i>
                      <b>{{item.custLinkmanEn}}</b>
                    </p>
                    <p>
                      <i>所属区域</i>
                      <b></b>
                    </p>
                    <p>
                      <i>省份(英文)</i>
                      <b>{{item.provinceEn}}</b>
                    </p>
                    <p>
                      <i>城市(英文)</i>
                      <b>{{item.cityEn}}</b>
                    </p>
                    <p>
                      <i>通讯地址(中文)</i>
                      <b>{{item.addressCn}}</b>
                    </p>
                    <p>
                      <i>通讯地址(英文)</i>
                      <b>{{item.addressEn}}</b>
                    </p>
                    <p>
                      <i>邮政编码</i>
                      <b>{{item.zipCode}}</b>
                    </p>
                    <p>
                      <i>电话</i>
                      <b>{{item.tel}}</b>
                    </p>
                    <p>
                      <i>手机号码</i>
                      <b>{{item.cellPhoneNumber}}</b>
                    </p>
                    <p>
                      <i>电子邮箱</i>
                      <b>{{item.email}}</b>
                    </p>
                  </span>
                  <span slot="footer"
                        class="dialog-footer">
                    <el-button @click="item.dialogVisible = false">关闭</el-button>
                  </span>
                </el-dialog>

              </label>
              <label><input type="radio"
                       value="newDomainInfo"
                       v-model="domainTemplateId">使用新的域名注册信息</label>
              <dl class="regnewinfo"
                  v-if="domainTemplateId==='newDomainInfo'">
                <dt class="clearfix">
                  <b>所有者类型：</b>
                  <div class="selType2 fl">
                    <span @click="form.registrantType='I'"
                          :class="{selCur:form.registrantType==='I'}">个人用户</span>
                    <span @click="form.registrantType='E'"
                          :class="{selCur:form.registrantType==='E'}">企业用户</span>
                  </div>
                  <a class="howsel fl">如何选择？</a>
                  <section class="fl">使用已实名的信息模板便于您注册域名后快速实名认证可在信息模板中创建和管理。</section>
                </dt>
                <dd>
                  <b>域名所有者（中文）：</b>
                  <div><input v-model="form.nameCn"
                           type="text" /></div>
                </dd>
                <dd>
                  <b>域名所有者（英文）：</b>
                  <div><input v-model="form.nameEn"
                           type="text" /></div>
                </dd>
                <dd>
                  <b>电子邮箱：</b>
                  <div><input v-model="form.email"
                           type="text" /></div>
                </dd>
                <dd>
                  <b></b>
                  <div class="save">
                    <button class="nextCur"
                            @click="saveTemplate">保存模板</button>
                    <!-- <button>放弃</button> -->
                  </div>
                </dd>
              </dl>
            </div>
            <div class="selban"
                 v-else>
              <label style="color:#108ee9;"><a href="javascript:;"
                   @click="activeLogin">登录后，查看域名注册模板</a></label>

            </div>
            <!-- <div class="promotion-panel mt20">
              <span class="zeng">赠</span>
              <span class="f12">{{domainPackageList[domainPackage].promotionName}}</span>
            </div> -->

            <div class="agree">
              <protocol-domain @input="changeChecked"
                               :acceptAgreement="acceptAgreement"></protocol-domain>
            </div>
          </section>
        </div>
      </Order-panel>
      <div class="total mt10">

        <p>总价费用：
          <i>￥{{domainPackageList[domainPackage].price}}</i>
        </p>
        <!-- <button @click="$router.go(-1)">上一步</button> -->
        <el-button :loading="nextButtonIsLoading"
                   :disabled="cartInfoVO&&cartInfoVO.deaiMoney==='--'"
                   style="padding:0;border-radius:0"
                   :class="{nextCur:acceptAgreement}"
                   @click="save">立即购买</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import banner from './components/header'
import recommend from './components/recommend'
import cTitle from './components/title'
import protocolDomain from './components/Protocol-domain'
import OrderPanel from './components/confirm-order-panel'

export default {
  data () {
    return {
      wasLogin: false,
      disabledQuery: false,
      initData: [],
      timeLong: 1,
      domainName: '',
      nextButtonIsLoading: false,
      domainTableIsLoading: false,
      isAcceptDomainTreaty: false,
      cartInfoVO: null,
      serviceGoodsList: [],
      cartGroupList: [],
      templateList: [],
      domainTemplateId: '',
      isShowTemplateForm: false,
      acceptAgreement: false,
      yearList: [{
        name: '1年',
        value: '1'
      }],
      domainServerList: [],
      domainPackage: 'jzbb',
      domainPackageList: {
        jzbb: {
          code: 'jzbb',
          price: '366.00',
          suffix: '.com、.cn、.net',
          promotionId: '10848648a15e11e99d6efa163e00f134',
          promotionName: '域名_建站必备后缀套餐',
          name: '建站必备',
          placeHolder: '建站必备域名含 .com、.cn、.net 三款后缀'
        },
        qypp: {
          code: 'qypp',
          price: '3666.00',
          promotionId: 'cd8e0c74a15e11e99d6efa163e00f134',
          promotionName: '域名_企业品牌保护套餐',
          suffix: '.网址、.中国、.企业',
          name: '企业品牌保护',
          placeHolder: '企业品牌保护含 .网址、.中国、.企业 三款后缀'
        }, dsqy: {
          code: 'dsqy',
          price: '1666.00',
          promotionId: '80ffa4eea15f11e99d6efa163e00f134',
          promotionName: '域名_电商企业专属套餐',
          suffix: '.公司、.网店、.网络',
          name: '电商企业专属',
          placeHolder: '电商企业专属含 .公司、.网店、.网络 三款后缀'
        }
      },
      domainServer: '',
      form: {
        registrantType: 'E',
        nameCn: '',
        nameEn: '',
        email: '',
        source: '3'
      },
      domainList: [],
      isQuery: false
    }
  },
  components: {
    banner,
    recommend,
    cTitle,
    protocolDomain,
    OrderPanel

  },
  methods: {
    activeLogin () {
      $.get(`${__shopURL}/cart/checkLogin`).then(
        response => {

        },
        err => {

        }
      )
    },
    query () {

      if (
        window.__PRERENDER_INJECTED &&
        window.__PRERENDER_INJECTED.prerender === 'domain'
      ) {
        return
      }
      this.isQuery = true
      this.disabledQuery = true
      this.domainList = []
      const reg = new RegExp(
        '^[A-Za-z０１２３４５６７８９－0-9-Ａ-Ｚａ-ｚ\u4e00-\u9fa5]+$'
      )
      this.domainName = this.domainName.trim()
      // 如果不输入，不执行操作
      if (!this.domainName) {
        this.disabledQuery = false
        return
      }

      // 完整域名拆分处理
      const index = this.domainName.indexOf('.')
      if (index !== -1) {
        this.domainName = this.domainName.substr(0, index)
      }

      if (this.domainName.length > 63) {
        this.$msgbox({
          type: 'error',
          message: '域名长度超出最大限制！'
        })
        this.disabledQuery = false
        return
      }

      if (!reg.test(this.domainName)) {
        if (this.language === 'cn') {
          this.$msgbox({
            title: '您输入的域名不符合注册规则，请重新输入',
            type: 'error',
            message:
              '提示：中文域名至少需要含有一个中文文字，可以包含中文、字母a-z(大小写等价)、数字0-9或者半角的连接符“-”，“-”不能放在开头或者结尾，输入内容不能超过63个字符，最多可以注册19个汉字。'
          })
        } else {
          this.$msgbox({
            title: '您输入的域名不符合注册规则，请重新输入',
            type: 'error',
            message:
              '提示：域名可由英文字母（a-z,不区分大小写）、数字（0-9）、连字符“-”（即中横线）,不能使用空格及特殊字符（如！、$、&、？等），“-”不能单独填写或连续使用，不能放在开头或结尾，输入内容不能超过63个字符。'
          })
        }

        this.disabledQuery = false
        return
      }
      let promiseArr = []
      this.domainPackageList[this.domainPackage].suffix.split("、").forEach(ele => {
        promiseArr.push(new Promise((resolve, reject) => {
          $.get(
            `${__shopURL}/domain/findDomainStatus?domainName=${
            this.domainName
            }&domainSuffix=${ele}`
          ).then(response => {
            if (!Array.isArray(this.domainList)) {
              this.domainList = []
            }
            this.domainList.push({ domainName: this.domainName + ele, buyStatus: response.domainStatus })
            resolve()
          })
        }))


      })
      Promise.all(promiseArr).then(() => {
        this.disabledQuery = false
      })
      console.log(this.domainList)
    },
    changeChecked (v) {
      this.acceptAgreement = v
    },
    save () {

      if (
        window.__PRERENDER_INJECTED &&
        window.__PRERENDER_INJECTED.prerender === 'domain'
      ) {
        return
      }
      if (!this.acceptAgreement) {
        this.$msgbox({
          // title:'',
          type: 'error',
          message: '请先同意《中企动力域名注册服务协议》'
        })
        return
      }
      if (this.wasLogin) {
        if (!this.domainList || this.domainList.length === 0) {
          this.$msgbox({
            type: 'error',
            message: '没有选中任何域名！'
          })
          return
        }
        var allowRegiste = this.domainList.every(ele => {
          return ele.buyStatus == 2
        })
        if (!allowRegiste) {
          this.$msgbox({
            type: 'error',
            message: '域名不可注册！'
          })
          return
        }
        if (!this.domainList || this.domainList.length === 0) {
          this.$msgbox({
            type: 'error',
            message: '没有选中任何域名！'
          })
          return
        }
        if (!this.domainTemplateId || this.domainTemplateId === 'newDomainInfo') {
          this.$msgbox({
            type: 'error',
            message: '没有选中任何域名模板！'
          })
          return
        }
      }

      var domainInfo = this.domainPackageList[this.domainPackage].suffix.split("、").map(ele => {
        return {
          domainName: this.domainName,
          domainSuffix: ele,
          TIME_LONG: '1',
          NUM: '1'
        }
      })

      const data = {
        domainTemplateId: this.domainTemplateId,
        serviceGoodsId: this.domainServer,
        selectedPromotions: this.domainPackageList[this.domainPackage].promotionId,
        domainList: domainInfo
      }

      this.nextButtonIsLoading = true

      $.post(`${__shopURL}/order/savedomaingrouporder`, {
        data: JSON.stringify(data)
      }).then(response => {
        this.nextButtonIsLoading = false
        if (!response || !response.orderid) {
          this.$message({
            type: 'error',
            message: response.msg || '错误'
          })
          return
        }

        window.location.href = window.location.protocol + '//' + window.location.host + `/payment/index.html?orderid=${response.orderid}`
      })
    },
    saveTemplate () {

      if (
        window.__PRERENDER_INJECTED &&
        window.__PRERENDER_INJECTED.prerender === 'domain'
      ) {
        return
      }
      $.post(`/security/domainTemplate/addForOrder`, {
        data: JSON.stringify({ domainTemplateVo: this.form })
      }).then(response => {
        if (response && response.status) {
          this.$message({
            type: 'error',
            message: response.msg
          })
          return
        }
        response.domainTemplateVo.dialogVisible = false
        this.templateList.push(response.domainTemplateVo)
        this.domainTemplateId = response.domainTemplateVo.id
        // console.log('template', response)
      })
    },
    getDomainTemplateList () {

      if (
        window.__PRERENDER_INJECTED &&
        window.__PRERENDER_INJECTED.prerender === 'domain'
      ) {
        return
      }
      $.get(`/domainTemplate/list`, { pageSize: 999 }).then(
        response => {
          this.wasLogin = response.isLogin
          if (response.isLogin) {
            this.templateList = response.domainTemplateList.map(v => {
              v.dialogVisible = false
              return v
            })
            this.domainTemplateId =
              (this.templateList[0] && this.templateList[0].id) || 'newDomainInfo'
          }

          // console.log(999, response)

        }
      )
    },
    getDomainServer () {
      $.get(`/domainGoods/findDomainServiceGoods?appId=300`).then(
        response => {
          this.domainServerList = response.serviceGoodsList
          this.domainServerList.length = 1
          this.domainServer =
            (response.serviceGoodsList[0] && response.serviceGoodsList[0].id) || ''
        }
      )

    },
  },

  created () {
    this.domainPackage = this.$route.query.code
    this.getDomainTemplateList()
    this.getDomainServer()
  }
}
</script>

<style lang="scss">
@import "../static/css/buy-cps.scss";
</style>



// WEBPACK FOOTER //
// src/buy-company-package-server.vue